export default "__VITE_ASSET__CGkg8$GC__"